import {IDocumentObservation} from '../message-models/document-observation.interface';
import {Observation} from './observation.class';

export class DocumentObservation implements IDocumentObservation {
  id: string;
  documentId: string;
  observationId:string;
  observation: Observation;
  constructor(iDocumentObservation: IDocumentObservation) {
    this.id = iDocumentObservation.id || '00000000-0000-0000-0000-000000000000';
    this.documentId = iDocumentObservation.documentId || '00000000-0000-0000-0000-000000000000';
    this.observationId = iDocumentObservation.observationId || '00000000-0000-0000-0000-000000000000';
    this.observation = new Observation(iDocumentObservation.observation) ;
  }
}
